<template>
  <b-row>
    <b-col cols="6">
      <b-form-group label="Classificação da Contrapartida:">
        <b-form-select
          v-model="modelLocal.tipo_contrapartida"
          :state="validateState('tipo_contrapartida')"
          :options="tipos_contrapartida"
        />
        <template #invalid-feedback> Este campo é obrigatório </template>
      </b-form-group>
    </b-col>
    <b-col cols="6" v-show="!isVairableValue">
      <b-form-group label="Valores em:">
        <b-form-radio-group
          v-model="modelLocal.unidade"
          buttons
          :button-variant="isVairableValue ? 'secondary' : 'outline-exitos'"
          class="cursor-pointer"
          :state="validateState('unidade')"
          :options="tipos_valor"
        />
      </b-form-group>
    </b-col>
    <b-col cols="6" v-show="!isVairableValue && isApplicable">
      <b-form-group label="Mínima:">
        <number-format
          v-model="modelLocal.minima"
          placeholder="mínima"
          :state="validateState('minima')"
          :decimals="decimals"
        />
        <template #invalid-feedback> Este campo é obrigatório </template>
      </b-form-group>
    </b-col>
    <b-col cols="6" v-show="!isVairableValue && isApplicable">
      <b-form-group label="Máxima:">
        <number-format
          v-model="modelLocal.maxima"
          placeholder="máximo"
          :state="validateState('maxima')"
          :decimals="decimals"
        />
        <template #invalid-feedback> Este campo é obrigatório </template>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group label="Descrição:">
        <b-form-textarea
          v-model="modelLocal.descricao"
          placeholder="Insira a descrição da contra partida..."
          :state="validateState('descricao')"
        />
        <template #invalid-feedback> Este campo é obrigatório </template>
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { requiredIf, required, decimal } from "vuelidate/lib/validators";

import NumberFormat from "@/components/Form/NumberFormat.vue";

export default {
  name: "DadosContrapartida",
  mixins: [validationMixin],
  components: { NumberFormat },
  data() {
    return {
      tipos_valor: [
        { value: "R$", text: "Valor (R$)" },
        { value: "%", text: "Porcentagem (%)" },
        { value: null, text: "Não se aplica" },
      ],
      contrapartida: this.value,
    };
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipo_contrapartida: "",
        descricao: "",
        minima: 0,
        maxima: 0,
      }),
    },
  },
  computed: {
    ...mapGetters("oportunidades", ["tipos_contrapartida"]),
    modelLocal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    isVairableValue() {
      return ["negociavel"].includes(this.value.tipo_contrapartida);
    },
    isApplicable() {
      return this.value.unidade !== null;
    },
    decimals() {
      return this.value.unidade == "%" ? 1 : 2;
    },
  },
  validations: {
    contrapartida: {
      tipo_contrapartida: {
        required,
      },
      unidade: {
        required: requiredIf(function (model) {
          return ["financeira", "bens-servico"].includes(model.tipo);
        }),
      },
      minima: {
        required: requiredIf(function (model) {
          return model.tipo == 1;
        }),
        decimal,
      },
      maxima: {
        required: requiredIf(function (model) {
          return model.tipo == 1 || model.tipo == 2;
        }),
        decimal,
      },
      descricao: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.contrapartida[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.contrapartida.$touch();
      return !this.$v.contrapartida.$anyError;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.contrapartida = value;
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer !important;
}
</style>
